module.exports = __webpack_public_path__ + "img/tiny-ge-logo.e8848556.png";